import { createAuthClient as createBetterAuthClient } from "better-auth/react";

export const createAuthClient = () => {
  return createBetterAuthClient({
    baseURL: import.meta.env.VITE_API_URL || window.location.origin,
  });
};

export type AuthClient = ReturnType<typeof createAuthClient>;
export type Session = Awaited<ReturnType<AuthClient["getSession"]>>["data"];
